/**
 * The device surface this document runs as (KAN-1785): the Outlook pane
 * today, the desktop app and Word or Excel later. A surface runs some of a
 * chat's tools itself, on the user's device (see `lib/device-tools/`).
 *
 * The surface says so twice. When it creates a chat, the server records the
 * surface on the session, and that alone decides the chat's device tools for
 * its whole life. With every turn it sends, it says it is the device following
 * that turn, so a device tool reaches it; a turn sent from anywhere else gets
 * "not connected" for those tools at once.
 *
 * Set by the surface's own screen while it is mounted, and read where chats
 * are created and turns are sent. One per document.
 */

/** The surfaces the server has tools for (`apps/api/app/models/device_tool_schemas.py`). */
export type ClientSurface = 'outlook';

let activeSurface: ClientSurface | null = null;

/** Declare the surface this document runs as; `null` when it stops being one. */
export function setClientSurface(surface: ClientSurface | null): void {
  activeSurface = surface;
}

/** The request field naming this document's surface; empty in the ordinary app. */
export function clientSurfaceField(): { clientSurface?: ClientSurface } {
  return activeSurface ? { clientSurface: activeSurface } : {};
}
